import React from "react";

export default class Button extends React.Component {
	render() {
		return (
			<div onClick={this.props.onClick} style={{ cursor: 'pointer', width: 100, border: 0, padding: 10, borderColor: '#6d6d6d', borderStyle: 'solid', borderWidth: 2, display: 'flex', justifyContent: 'center', ...(this.props.style) }}>
				{this.props.text}
			</div>
		)
	}
}